import { getDetailsNhboundrieslist } from "../../../modules/Graphql/neighborhoodboundriesgraphql";

export async function fetchNeighborhoods({
  start = 0,
  limit = 10,
  filter,
  city,
  state,
}) {
  const getdata = {
    start,
    limit,
    order: ["medianprice", "value", "appreciation"].includes(filter)
      ? "ASC"
      : "DESC",
    orderBy: filter,
    fields: [{ name: "postalcity_name", value: city, operator: "=" }],
    userId: "",
  };

  const result = await getDetailsNhboundrieslist(getdata);
  return result?.data?.getDetailsNhBoundries || [];
}

export default function Dummy() {
  return null;
}
